module.exports = __webpack_public_path__ + "static/media/grid.8056bc26.svg";